<template>
  <v-form>
    <v-card-text>
      <v-text-field
        v-model="item.firstname"
        :error-messages="firstnameErrors"
        :label="$t('administration.user.firstname')"
        clearable
        prepend-icon="mdi-account-circle"
        required
        @input="$v.item.firstname.$touch()"
        @blur="$v.item.firstname.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="item.lastname"
        :error-messages="lastnameErrors"
        :label="$t('administration.user.lastname')"
        clearable
        prepend-icon="mdi-account-circle"
        required
        @input="$v.item.lastname.$touch()"
        @blur="$v.item.lastname.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="item.email"
        :error-messages="emailErrors"
        :label="$t('administration.user.email')"
        clearable
        prepend-icon="mdi-account-circle"
        required
        @input="$v.item.email.$touch()"
        @blur="$v.item.email.$touch()"
      ></v-text-field>
    </v-card-text>
  </v-form>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  export default {

    name: 'ProfilForm',
    mixins: [validationMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        default: () => {}
      },
      initialValues: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        firstname: null,
        lastname: null,
        email: null,
      }
    },
    computed: {

      // eslint-disable-next-line
      item() {
        return this.initialValues || this.values;
      },

      firstnameErrors() {
        const errors = [];

        if (!this.$v.item.firstname.$dirty) return errors;

        has(this.violations, 'firstname') && errors.push(this.violations.firstname);

        !this.$v.item.firstname.required && errors.push(this.$t('global.field_required'));

        return errors;
      },
      lastnameErrors() {
        const errors = [];

        if (!this.$v.item.lastname.$dirty) return errors;

        has(this.violations, 'lastname') && errors.push(this.violations.lastname);

        !this.$v.item.lastname.required && errors.push(this.$t('global.field_required'));

        return errors;
      },
      emailErrors() {
        const errors = [];

        if (!this.$v.item.email.$dirty) return errors;

        has(this.violations, 'email') && errors.push(this.violations.email);

        !this.$v.item.email.required && errors.push(this.$t('global.field_required'));

        return errors;
      },

      violations() {
        return this.errors || {};
      }
    },
    methods: {

    },
    validations: {
      item: {
        firstname: {
          required,
        },
        lastname: {
          required,
        },
        email: {
          required,
        },
      }
    }
  }
</script>
